
export default function IconClose(props) {
  const { size = "1rem ", ...rest } = props;
  return (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path d="M4.26732 12.6666L3.33398 11.7333L7.06732 7.99992L3.33398 4.26659L4.26732 3.33325L8.00065 7.06659L11.734 3.33325L12.6673 4.26659L8.93398 7.99992L12.6673 11.7333L11.734 12.6666L8.00065 8.93325L4.26732 12.6666Z" fill="currentColor" />
    </svg>
  );
}